import React from 'react';
import { ArrowLeft } from 'lucide-react';

const C = {
  primary: 'var(--c-primary)',
  bg: 'var(--c-bg)',
  surface: 'var(--c-surface)',
  border: 'var(--c-border)',
  text: 'var(--c-text)',
  textMuted: 'var(--c-textMuted)',
};

// The Tech Stack Request form lives in Typeform. A submission is reviewed by the
// owning team, who email the helpdesk inbox -- which opens a ticket through the
// normal email-intake path. Nothing is created here; this view is purely the embed.
const TYPEFORM_ID = 'FA5p1vMW';

const TechStackRequest: React.FC<{ onBack: () => void }> = ({ onBack }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <button
        onClick={onBack}
        style={{
          color: C.primary, display: 'inline-flex', alignItems: 'center', gap: 4,
          marginBottom: 12, fontSize: 13, background: 'none', border: 'none',
          padding: 0, cursor: 'pointer',
        }}
      >
        <ArrowLeft size={14} /> Choose a different form
      </button>

      <h1 style={{ color: C.primary, fontSize: 26, margin: '0 0 6px' }}>Tech Stack Request</h1>
      <p style={{ color: C.textMuted, margin: '0 0 16px', maxWidth: 640 }}>
        Fill out the form below. It is reviewed by the team and a ticket is opened
        automatically once you submit, so you do not need to do anything else here.
      </p>

      <div style={{
        height: 'calc(100vh - 230px)', minHeight: 620,
        background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8,
        overflow: 'hidden',
      }}>
        <iframe
          title="Tech Stack Request"
          src={`https://form.typeform.com/to/${TYPEFORM_ID}`}
          style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
          allow="camera; microphone; autoplay; encrypted-media; fullscreen;"
        />
      </div>
    </div>
  );
};

export default TechStackRequest;
